import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { browserCompatibility } from './services/BrowserCompatibility'

/**
 * Apply the persisted theme preference to <html data-theme> BEFORE React renders.
 * Otherwise useMapStyle (which reads data-theme in its useState initializer) races
 * against CollapsiblePanel's useEffect that sets it — the map would fetch dark tiles
 * on load while the sidebar showed light mode.
 */
(function applyPersistedTheme() {
  try {
    const pref = localStorage.getItem('stationExplorer_theme');
    const root = document.documentElement;
    if (pref === 'light' || pref === 'dark') {
      root.setAttribute('data-theme', pref);
      root.style.colorScheme = pref;
    }
    // pref === 'system' or null → leave data-theme unset; useMapStyle falls back to
    // window.matchMedia which is the correct behavior for system preference.
  } catch { /* localStorage unavailable — accept system fallback */ }
})();

// Initialize browser compatibility checks
browserCompatibility.initialize().catch((error) => {
  console.error('Failed to initialize browser compatibility:', error);
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
